module.exports = require("./ca-FR");